import {ProjectBranchesListQuery, ProjectSourcesListQuery} from "@/1_webapi/query";
import BranchList from "@/3_view/pages/BranchList/BranchList.store";
import KeywordList from "@/3_view/pages/KeywordList/KeywordList.store";
import KeywordsManagement from "@/3_view/pages/KeywordsManagement/KeywordsManagement.store";
import RankByBranch from "@/3_view/pages/RankByBranch/RankByBranch.store";
import RankByKeyword from "@/3_view/pages/RankByKeyword/RankByKeyword.store";
import {api} from "@/main";
import Vue from 'vue'
import Vuex from 'vuex'
import {PositionHistoryMock} from "./1_webapi/mocks";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        KeywordList,
        BranchList,
        RankByKeyword,
        RankByBranch,
        KeywordsManagement,
    },
    actions: {
        setCurrentTab(ctx, value) {
            ctx.commit('updateCurrentTab', value)
        },
        fetchPositionHistory(ctx, entity_id, source_id) {
            ctx.commit('historyPositionPopup', PositionHistoryMock.data)
        },
        async fetchDataForFilters(ctx) {
            await api.common.fetchProjectBranchesList(ctx.state.projectBranchesListDomain)
            await api.common.fetchProjectSourcesList(ctx.state.projectSourcesListDomain)
        },
    },
    mutations: {
        updateCurrentTab(state, value) {
            state.currentTab = value
        },
    },
    state: {
        currentTab: 'branches', // keywords
        historyPositionPopup: [],
        projectBranchesListDomain: { query: new ProjectBranchesListQuery() },
        projectSourcesListDomain: { query: new ProjectSourcesListQuery() },
        init: {
            routeQuery: null,
            routeQueryIsAlreadySet: false,
        },
        currentPageQuery: null, // Запрос, который сейчас самый главный на странице
    },
    getters: {
        currentTab(state) {
            return state.currentTab
        },
        branchesList(state) {
            const query = state.projectBranchesListDomain.query
            return query.response && query.response.data
        },
        sourcesList(state) {
            const query = state.projectSourcesListDomain.query
            return query.response && query.response.data
        },
    },
})